import { createApp } from 'vue'
import '@wastedondestiny/destiny-library/dist/style.css'
import './style.css'
import App from './App.vue'
import router from './routes'
const app = createApp(App)

app.use(router)
app.mount('#app')

console.log('%cloot.report loaded!', 'color:yellow;-webkit-text-stroke:1px black;font-size:36px;')
setTimeout(() => console.log('You wouldn\'t paste code a stranger online gave you into this console, would you?'), 1000)
